var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafety(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 512 512",
    id: "Layer_2",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "      M338.212,173.11c5.58,26.957-0.463,42.937-5.699,51.913l0,0c-3.969,6.804-6.528,14.337-7.523,22.151l-1.143,8.964      c-1.527,11.984-13.066,29.203-20.552,37.729c0,0-11.771,36.639-43.838,36.639s-46.97-37.967-46.97-37.967      c-6.865-8.303-17.971-25.031-19.421-36.401l-1.39-10.905c-0.835-6.553-2.771-12.917-5.725-18.826l-1.349-2.697      c-4.074-8.149-6.196-17.135-6.196-26.245v-41.735",
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "      M215.074,299.093l-4.133,49.621l-96.622,33.294c-12.588,4.338-22.535,14.143-27.053,26.668L69.39,458.238",
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "      M300.228,302.929l4.133,45.785l95.442,32.887c13.255,4.567,23.54,15.179,27.691,28.571l17.897,49.066",
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "      M198.864,352.876c0,0,2.188,49.352,60.472,49.352s57.101-49.352,57.101-49.352",
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 228.945,
    cy: 211.349,
    fill: "#474747",
    r: 9.432
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 290.448,
    cy: 211.349,
    fill: "#474747",
    r: 9.432
  })), /*#__PURE__*/React.createElement("path", {
    d: "     M300.228,91.752c0,0-11.37-37.023-81.592-27.243c0,0-33.193,5.982-42.193-1.645l8.093,16.531c0,0-10.649,7.279-29.707-2.087",
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "     M292.325,79.934c0,0,22.123-15.832,43.073,5.189c30.048,30.149,2.814,87.987,2.814,87.987     c-47.253,4.076-53.293-18.616-53.293-18.616",
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "     M154.829,77.308c-5.821,38.602,3.561,95.655,74.116,88.96c70.555-6.695,71.283-42.36,71.283-42.36",
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15,
    x1: 203.235,
    x2: 182.537,
    y1: 166.808,
    y2: 219.09
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15,
    x1: 321.632,
    x2: 334.756,
    y1: 173.6,
    y2: 220.781
  })), /*#__PURE__*/React.createElement("path", {
    d: "    M192.886,253.035l47.795-21.376c11.873-5.31,25.512-4.959,37.095,0.956l46.071,23.522",
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15,
    x1: 259.458,
    x2: 259.458,
    y1: 256.433,
    y2: 299.093
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "     M105.564,298.137L105.564,298.137c-18.908,0-34.866-15.199-37.251-33.956l-3.315-28.359     c-3.106-24.434,15.935-47.189,40.565-47.189h0c24.63,0,43.671,22.755,40.565,47.189l-3.315,28.359     C140.43,282.938,124.472,298.137,105.564,298.137z",
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "     M172.89,331.162l-30.922-5.128c-7.834-2.027-14.447-9.095-14.447-17.186v-15.44",
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "     M83.036,293.407v15.474c0,8.076-6.591,15.134-14.405,17.176l-30.469,5.061c-14.205,3.712-24.115,16.544-24.115,31.226",
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("path", {
    d: "    M69.312,257.022l25.686-5.525c6.947-1.217,14.034-1.22,20.982-0.007l25.836,5.533",
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "     M406.373,298.137L406.373,298.137c18.908,0,34.866-15.199,37.251-33.956l3.315-28.359c3.106-24.434-15.935-47.189-40.565-47.189     h0c-24.63,0-43.671,22.755-40.565,47.189l3.315,28.359C371.507,282.938,387.465,298.137,406.373,298.137z",
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "     M339.047,331.162l30.922-5.128c7.834-2.027,14.447-9.095,14.447-17.186v-15.44",
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "     M428.901,293.407v15.474c0,8.076,6.591,15.134,14.405,17.176l30.469,5.061c14.205,3.712,24.115,16.544,24.115,31.226",
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("path", {
    d: "    M442.625,257.022l-25.686-5.525c-6.947-1.217-14.034-1.22-20.982-0.007l-25.836,5.533",
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.fd99e4ef761e3c2047f4c46c397d54e6.svg";
export { ForwardRef as ReactComponent };